import React, { useEffect, useState } from "react";
import axios from "axios";
import "../../css/Popup.css"; 
import logo from "../../images/For website copy.jpg"; 
import indian from "../../images/india.jpeg"; 
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const LeadPopup = ({ projectid, isOpen, onClose }) => {
  const [project, setProject] = useState({});
  const [media, setMedia] = useState([]);
  const [floorplans, setFloorplans] = useState([]);

  useEffect(() => {
    axios.get(`/api/get-newproject/${projectid}`)
      .then(res => {
        setProject(res.data.project);
        setMedia(res.data.media);
        setFloorplans(res.data.floorplans);
      })
      .catch(err => {
        console.error("Error fetching project:", err);
      });
  }, [projectid]);

  if (!isOpen) return null;

  const handleSubmit = async (event) => {
    event.preventDefault();
 const requirements = `intersted in ${project.bpn}`;
    const formData = {
      name: event.target.name.value,
      email: event.target.email.value,
      mobile: event.target.mobile.value,
      requirement: requirements ,
      propertyid: project.projectid,
      propertyname:project.bpn,
      projectlocality:project.locality
    };

    try {
      const response = await axios.post("/api/newproject-leads", formData);
      alert("Submitted successfully!");
      onClose(); // Close popup after success
    } catch (err) {
      console.error("Error submitting lead:", err);
      alert("Submission failed. Please try again.");
    }
   
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <span className="popup-close fw-bold" onClick={onClose}>
          &times;
        </span>
        <div className="popup-body">
          <div className="popup-image">
            <img src={media[0]?.image} alt="Pincode Pillars" className="popup-img" />
          </div>
          <div className="popup-form">
            <h2>
              FREE Consultation by{" "}
              <span className="highlight">Professionals</span>
            </h2>
            <h3 className="project-name">{project.bpn}</h3>
            <h3>{project.locality}</h3>
            {/* <img
              src={logo}
              alt="Backbone Pillars Logo"
              className="popup-logo"
            /> */}
            <form className="form1" onSubmit={handleSubmit}>
              <input className="form-control" type="text" id="name" name="name" required placeholder="Name" />
              <input className="form-control" type="email" id="email" name="email" required placeholder="Email" />
              <div className="mobile-input form-control">
                <div className="country-code">
                  <img src={indian} alt="India Flag" className="flag-icon" />
                  <span className="code">+91</span>
                </div>
                <input
                  type="tel"
                  id="mobile"
                  name="mobile"
                  required
                  placeholder="Mobile*"
                  className="mobile-number-input"
                />
              </div>
            
              <button className="main-btn1 pointer text-center animate fw-bold" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
